import React from 'react';
import cn from 'classnames';

import type { SelectionProps } from 'components/form/Selection';
import Selection from 'components/form/Selection';

import styles from './Toggle.module.scss';

type Size = 'small' | 'large';

interface CustomToggleProps {
  toggleSize?: Size;
}

type ToggleProps = Omit<SelectionProps, 'type'> & CustomToggleProps;

export type { ToggleProps };

export const Toggle: React.FC<ToggleProps> = (props: ToggleProps) => {
  const { className, toggleSize = 'large' } = props;
  const contentClassNames = cn(
    {
      [styles.Toggle]: true,
      [styles['label-first']]: props.labelFirst,
      [styles[`Toggle-${toggleSize}`]]: toggleSize,
    },
    className
  );

  return (
    <Selection
      {...props}
      className={contentClassNames}
      type="checkbox"
      dataTestid="Toggle"
    />
  );
};
